import { CSSResultArray } from 'lit';
import host from '@maersk-global/mds-components-utils/host/host.styles.js';
import style from './mc-segmented-control-item.scss';
import tokens from '@maersk-global/mds-design-tokens/implementation/core/segmented-control-item/js/design-tokens-px.css.js';
export const styles: CSSResultArray = [host, tokens, style];
